import { useEffect, useState } from 'react';
import { t } from 'i18next';
import { Link } from 'react-router-dom';
import { Table } from 'semantic-ui-react';
import { getAsync } from '../../../components/helper/axiosHelper';
import LoadingAnimation from '../../../components/LoadingAnimation';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { toast } from 'react-toastify';
function NotificationTables() {
  const [gwaServiceApproval, setgwaServiceApproval] = useState([]);
  const [gwaProjectApproval, setgwaProjectApproval] = useState([]);
  const [sdProjectApproval, setsdProjectApproval] = useState([]);
  const [sdProjectPublish, setsdProjectPublishl] = useState([]);
  const [epVolunterRegistrationApproval, setepVolunterRegistrationApproval] = useState([]);

  useEffect(() => {
    // Pending GWA Service Approvals

    const fetchGWAServicesData = async () => {
      try {
        await getAsync('AP_Notifications/GetGWAServicesCountPendingApproval')
          .then((res) => {
            setgwaServiceApproval(res.notificationsCount);
          })
          .catch((err) => {
             toast.error(t('Something went wrong, Please try again!'));
          });

        // setNotificationsCount( notificationsCount)
        // const response = await axios.get(`${reactURL}AP_Notifications/GetGWAProjectsCountPendingApproval`);
        // const { notificationCount } = response.data;
        // setNotificationCounts(prevCounts => [...prevCounts, notificationCount]);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // Pending GWA Project Approvals

    const fetchGwaProjectData = async () => {
      try {
        await getAsync('AP_Notifications/GetGWAProjectsCountPendingApproval')
          .then((res) => {
            setgwaProjectApproval(res.notificationsCount);
          })
          .catch((err) => {
            toast.error(t('Something went wrong, Please try again!'));
          });

        // setNotificationsCount( notificationsCount)
        // const response = await axios.get(`${reactURL}AP_Notifications/GetGWAProjectsCountPendingApproval`);
        // const { notificationCount } = response.data;
        // setNotificationCounts(prevCounts => [...prevCounts, notificationCount]);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // SDProject Approval

    const fetchSdProjectApproval = async () => {
      try {
        await getAsync('AP_Notifications/GetSDProjectsCountPendingApproval')
          .then((res) => {
            setsdProjectApproval(res.notificationsCount);
          })
          .catch((err) => {
            toast.error(t('Something went wrong, Please try again!'));
          });

        // setNotificationsCount( notificationsCount)
        // const response = await axios.get(`${reactURL}AP_Notifications/GetGWAProjectsCountPendingApproval`);
        // const { notificationCount } = response.data;
        // setNotificationCounts(prevCounts => [...prevCounts, notificationCount]);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    const fetchSdProjectPublish = async () => {
      try {
        await getAsync('AP_Notifications/GetSDProjectsCountPendingPublishApproval')
          .then((res) => {
            setsdProjectPublishl(res?.notificationsCount);
          })
          .catch((err) => {
             toast.error(t('Something went wrong, Please try again!'));
          });

        // setNotificationsCount( notificationsCount)
        // const response = await axios.get(`${reactURL}AP_Notifications/GetGWAProjectsCountPendingApproval`);
        // const { notificationCount } = response.data;
        // setNotificationCounts(prevCounts => [...prevCounts, notificationCount]);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // EPVolunteer Registration Approval
    const fetchEpVolunteerRegistrationApproval = async () => {
      try {
        await getAsync('AP_Notifications/GetEPVolunteerEventRegCountPendingApproval')
          .then((res) => {
            setepVolunterRegistrationApproval(res.notificationsCount);
          })
          .catch((err) => {
             toast.error(t('Something went wrong, Please try again!'));
          });

        // setNotificationsCount( notificationsCount)
        // const response = await axios.get(`${reactURL}AP_Notifications/GetGWAProjectsCountPendingApproval`);
        // const { notificationCount } = response.data;
        // setNotificationCounts(prevCounts => [...prevCounts, notificationCount]);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchGWAServicesData();
    fetchGwaProjectData();
    fetchSdProjectApproval();
    fetchEpVolunteerRegistrationApproval();
    fetchSdProjectPublish();
  }, []);

  return (
    <>
      <div className="container ">
        <div className="row justify-center ">
          {/*  GWA Service Approvals */}
          {gwaServiceApproval <= 0 ? null : (
            <div className="col-lg-11 pt-9 ">
              <h3 className="font-bold text-base text-center py-3 text-customgreen">
                {' '}
                {t('Pending Goodwill Ambassador Service Approvals')}
              </h3>
              <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <Table className="text-sm text-left rtl:text-right  ">
                  <Table.Header className="font-bold  bg-customgreen text-white uppercase ">
                    <Table.Row>
                      <Table.HeaderCell className="w-1/12  text-white">{t('sNo')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-5/12 text-white">{t('Approval Details')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-3/12 text-white">{t('Total Count')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-3/12 text-white">{t('Action')}</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body className="align-middle">
                    <Table.Row>
                      {' '}
                      {/* Set key on Table.Row */}
                      <Table.Cell>1</Table.Cell>
                      <Table.Cell>{t('Good Will Ambassador Service Approvals')}</Table.Cell>
                      <Table.Cell>{gwaServiceApproval}</Table.Cell>
                      <Table.Cell>
                        <Link to="/GWARegisterApprovalList">
                          <button className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center">
                            {/* <LinkOutlinedIcon /> */}
                            {<VisibilityOutlinedIcon />}
                          </button>
                        </Link>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>

                  <Table.Footer></Table.Footer>
                </Table>
              </div>
            </div>
          )}

          {/* GWA Project Approvals */}
          {gwaProjectApproval <= 0 ? null : (
            <div className="col-lg-11 pt-9 ">
              <h3 className="font-bold text-base text-center py-3 text-customgreen">
                {t('Pending Goodwill Ambassador Project Approvals')}
              </h3>
              <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <Table className="text-sm text-left rtl:text-right ">
                  <Table.Header className="font-bold text-white bg-customgreen uppercase  ">
                    <Table.Row>
                      <Table.HeaderCell className="w-1/12  text-white">{t('sNo')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-5/12 text-white">{t('Approval Details')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-3/12 text-white">{t('Total Count')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-3/12 text-white">{t('Action')}</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body className="align-middle">
                    <Table.Row>
                      <Table.Cell>1</Table.Cell>
                      <Table.Cell>{t('Good Will Ambassador Project Approvals')}</Table.Cell>
                      <Table.Cell>{gwaProjectApproval}</Table.Cell>

                      <Table.Cell>
                        <Link to="/GWAProjectApprovalList">
                          <button className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center">
                            {/* <LinkOutlinedIcon /> */}
                            {<VisibilityOutlinedIcon />}
                          </button>
                        </Link>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>

                  <Table.Footer></Table.Footer>
                </Table>
              </div>
            </div>
          )}

          {/* SD Project Approvals */}
          {sdProjectApproval <= 0 ? null : (
            <div className="col-lg-11 pt-9 ">
              <h3 className="font-bold text-base text-center py-3 text-customgreen">
                {t('Pending Service for Dead Project Approvals')}
              </h3>
              <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <Table className="text-sm text-left rtl:text-right ">
                  <Table.Header className="font-bold text-white bg-customgreen uppercase  ">
                    <Table.Row>
                      <Table.HeaderCell className="w-1/12  text-white">{t('sNo')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-5/12 text-white">{t('Approval Details')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-3/12 text-white">{t('Total Count')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-3/12 text-white">{t('Action')}</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body className="align-middle">
                    <Table.Row>
                      <Table.Cell>1</Table.Cell>
                      <Table.Cell>{t('SD Project Approvals')}</Table.Cell>
                      <Table.Cell>{sdProjectApproval}</Table.Cell>

                      <Table.Cell>
                        <Link to="/SDProjectApprovalList">
                          <button className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center">
                            {/* <LinkOutlinedIcon /> */}
                            {<VisibilityOutlinedIcon />}
                          </button>
                        </Link>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>

                  <Table.Footer></Table.Footer>
                </Table>
              </div>
            </div>
          )}
          {/* SD Project Publish Approvals Approvals */}
          {sdProjectPublish <= 0 ? null : (
            <div className="col-lg-11 pt-9 ">
              <h3 className="font-bold text-base text-center py-3 text-customgreen">
                {t('Pending Service for Dead Project Publish Approvals')}
              </h3>
              <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <Table className="text-sm text-left rtl:text-right ">
                  <Table.Header className="font-bold text-white bg-customgreen uppercase  ">
                    <Table.Row>
                      <Table.HeaderCell className="w-1/12  text-white">{t('sNo')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-5/12 text-white">{t('Approval Details')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-3/12 text-white">{t('Total Count')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-3/12 text-white">{t('Action')}</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body className="align-middle">
                    <Table.Row>
                      <Table.Cell>1</Table.Cell>
                      <Table.Cell>{t('SD Project Approvals')}</Table.Cell>
                      <Table.Cell>{sdProjectPublish}</Table.Cell>

                      <Table.Cell>
                        <Link to="/SDPublishProjectList">
                          <button className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center">
                            {/* <LinkOutlinedIcon /> */}
                            {<VisibilityOutlinedIcon />}
                          </button>
                        </Link>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>

                  <Table.Footer></Table.Footer>
                </Table>
              </div>
            </div>
          )}

          {/* Volunteer Event Registration Approvals */}
          {epVolunterRegistrationApproval <= 0 ? null : (
            <div className="col-lg-11 pt-9 ">
              <h3 className="font-bold text-base text-center py-3 text-customgreen">
                {t('Pending Volunteer Event Registration Approvals')}
              </h3>
              <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <Table className="text-sm text-left rtl:text-right ">
                  <Table.Header className="font-bold text-white bg-customgreen uppercase  ">
                    <Table.Row>
                      <Table.HeaderCell className="w-1/12  text-white">{t('sNo')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-5/12 text-white">{t('Approval Details')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-3/12 text-white">{t('Total Count')}</Table.HeaderCell>
                      <Table.HeaderCell className="w-3/12 text-white">{t('Action')}</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body className="align-middle">
                    <Table.Row>
                      <Table.Cell>1</Table.Cell>
                      <Table.Cell>{t('Registration Approvals')}</Table.Cell>
                      <Table.Cell>{epVolunterRegistrationApproval}</Table.Cell>

                      <Table.Cell>
                        <Link to="/VolunteerApEventAprovalList">
                          <button className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center">
                            {/* <LinkOutlinedIcon /> */}
                            {<VisibilityOutlinedIcon />}
                          </button>
                        </Link>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default NotificationTables;
